import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaHome,
  FaTv,
  FaHorse,
  FaDog,
  FaTrophy,
  FaBasketballBall,
  FaBaseballBall,
  FaTableTennis,
  FaVolleyballBall,
  FaHockeyPuck,
  FaBullseye,
  FaFutbol,
  FaChartLine,
  FaLandmark,
  FaFistRaised,
  FaFootballBall,
} from 'react-icons/fa';
import { MdSportsKabaddi } from 'react-icons/md';
import { GiRooster } from 'react-icons/gi';
import sidebarCricketIcon from '../../assets/images/icons/sidebar-cricket.png';
import sidebarFootballIcon from '../../assets/images/icons/sidebar-football.png';
import sidebarTennisIcon from '../../assets/images/icons/sidebar-tennis.png';
import sidebarLiveCasinoIcon from '../../assets/images/icons/sidebar-live-casino.png';
import { FiMenu } from 'react-icons/fi';
import { useSelector, useDispatch } from 'react-redux';
import { isComingSoonRoute, showComingSoonToast } from '../../utils/comingSoonToast';

const PngIcon = ({ src, alt }) => (
  <img src={src} alt={alt} className="sports-nav-item__png" />
);

const sportsNavItems = [
  { label: 'HOME', route: '/', icon: <FaHome />, color: '#ffffff' },
  { label: 'IN-PLAY', route: '/live-games', icon: <FaTv />, color: '#e53935' },
  { label: 'CRICKET', route: '/games/cricket', icon: <PngIcon src={sidebarCricketIcon} alt="Cricket" />, isPng: true },
  { label: 'FOOTBALL', route: '/games/soccer', icon: <PngIcon src={sidebarFootballIcon} alt="Football" />, isPng: true },
  { label: 'TENNIS', route: '/games/tennis', icon: <PngIcon src={sidebarTennisIcon} alt="Tennis" />, isPng: true },
  { label: 'CASINO', route: '/live-casino', icon: <PngIcon src={sidebarLiveCasinoIcon} alt="Casino" />, isPng: true, requiresAuth: true },
  // { label: 'COCK FIGHT', route: '/games/cock-fight', icon: <GiRooster />, color: '#ffd700', textColor: '#ffd700' },
  // { label: 'POLITICS', route: '/games/politics', icon: <FaLandmark />, color: '#e53935' },
  // { label: 'SPORTS BOOK', route: '/sports-book', icon: <FaTrophy />, color: '#ffd700' },
  // { label: 'HORSE RACING', route: '/games/horse-racing', icon: <FaHorse />, color: '#a1887f' },
  // { label: 'GREYHOUND RACING', route: '/games/greyhound-racing', icon: <FaDog />, color: '#26a69a' },
  // { label: 'BINARY', route: '/games/binary', icon: <FaChartLine />, color: '#ffffff', highlighted: true },
  // { label: 'KABADDI', route: '/games/kabaddi', icon: <MdSportsKabaddi />, color: '#c62828', darkText: true },
  // { label: 'BASKETBALL', route: '/games/basketball', icon: <FaBasketballBall />, color: '#ff9800', darkText: true },
  // { label: 'BASEBALL', route: '/games/baseball', icon: <FaBaseballBall />, color: '#e53935', darkText: true },
  // { label: 'TABLE TENNIS', route: '/games/table-tennis', icon: <FaTableTennis />, color: '#e53935', darkText: true },
  // { label: 'VOLLEYBALL', route: '/games/volleyball', icon: <FaVolleyballBall />, color: '#ff5722', darkText: true },
  // { label: 'ICE HOCKEY', route: '/games/ice-hockey', icon: <FaHockeyPuck />, color: '#1565c0', darkText: true },
  // { label: 'RUGBY', route: '/games/rugby', icon: <FaFootballBall />, color: '#795548', darkText: true },
  // { label: 'MIXED MARTIAL ARTS', route: '/games/mma', icon: <FaFistRaised />, color: '#c62828', darkText: true },
  // { label: 'DARTS', route: '/games/darts', icon: <FaBullseye />, color: '#e53935', darkText: true },
  // { label: 'FUTSAL', route: '/games/futsal', icon: <FaFutbol />, color: '#ff9800', darkText: true },
];

const SportsNavStrip = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.account.userData);

  const handleNavClick = (item) => {
    if (isComingSoonRoute(item.route)) {
      showComingSoonToast();
      return;
    }
    if (item.requiresAuth && !userData?.token) {
      dispatch({ type: 'accountData/setLoginPopSate', payload: true });
      return;
    }
    navigate(item.route);
  };

  return (
    <nav className="sports-nav-strip" aria-label="Sports navigation">
      {sportsNavItems.map((item) => {
        const isActive = location.pathname === item.route ||
          (item.route !== '/' && location.pathname.startsWith(item.route));
        const classes = ['sports-nav-item'];
        if (item.highlighted) classes.push('sports-nav-item--highlighted');
        if (item.darkText) classes.push('sports-nav-item--dark-text');
        if (isActive) classes.push('sports-nav-item--active');

        return (
          <div
            key={item.label}
            className={classes.join(' ')}
            onClick={() => handleNavClick(item)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleNavClick(item)}
          >
            <span
              className="sports-nav-item__icon"
              style={!item.isPng ? { color: item.color } : undefined}
            >
              {item.icon}
            </span>
            <span
              className="sports-nav-item__label"
              style={item.textColor ? { color: item.textColor } : undefined}
            >
              {item.label}
            </span>
          </div>
        );
      })}
      {onMenuClick && (
        <button
          className="sports-nav-strip__hamburger"
          onClick={onMenuClick}
          type="button"
          aria-label="Open sidebar"
        >
          <FiMenu />
        </button>
      )}
    </nav>
  );
};

export default SportsNavStrip;
